<template>
  <div class="WorkMange">
    <div class="search" layout="inline">
      <a-input
        class="component"
        allowClear
        placeholder="搜索"
        :value="form.workOrderIdListStr"
        @input="inputR($event, 'workOrderIdListStr', 5)"
      >
        <template #prefix>
          <search-outlined style="color: #999999" />
        </template>
      </a-input>
      <a-select
        class="component"
        v-model:value="form.businessType"
        placeholder="请选择工单类型"
        allowClear
      >
        <a-select-option
          v-for="option in workOrderType"
          :value="option.eventType"
          :key="option.eventType"
        >
          {{ option.eventTypeContent }}
        </a-select-option>
      </a-select>
      <a-select
        class="component"
        v-model:value="form.state"
        placeholder="请选择工单状态"
        allowClear
      >
        <a-select-option :value="1" v-if="isAdmin">待分配</a-select-option>
        <a-select-option
          v-for="option in workOrderStatus"
          :value="option.value"
          :key="option.value"
        >
          {{ option.label }}
        </a-select-option>
      </a-select>
      <a-select
        v-model:value="form.stateTag"
        placeholder="请选择状态标签"
        class="component"
        :options="finishLabelMap[form.state]"
        allowClear
      ></a-select>
      <a-button @click="reset">重置</a-button>
      <a-button @click="getList" style="margin-left: 10px" type="primary">搜索</a-button>
    </div>
    <div class="table">
      <a-table
        :loading="loading"
        class="table"
        :bordered="true"
        :rowKey="(_, index) => index"
        :columns="columnsTodo"
        :data-source="dataSource"
        @change="onChangePage"
        :scroll="{ x: '100%', y: 330 }"
        :transformCellText="({ text }) => text ?? '--'"
        :sortDirections="['descend', 'ascend']"
        :pagination="pagination"
      >
        <template #workOrderId="data">
          <div class="beRemindedUser">
            {{ data.record.workOrderId }}
            <!-- 转交标识 -->
            <div v-if="data.record.transferFlag === 1" class="turnFlgM flg z-fixed-c">转交</div>
          </div>
        </template>
        <!-- 新增医生和患者标签 -->
        <template #reminder="{ record }">
          <roles :solerType="record.remindedType" />
          <span>{{ maskPatientName(record.reminder, record.remindedType) }}</span>
        </template>
        <!-- 工单任务 -->
        <template #eventContent="data">
          <div class="beRemindedUser">
            <div class="flg lgFlg z-fixed-c" v-if="data.record.activityFlag == 1">临观</div>
            <!-- 医生拼接 -->
            <span class="pre" v-if="data.record.eventId === 'PatientRegisterFillHealthInfo'">
              {{ `${data.record.ucDoctorName}${data.record.workOrderTask}` }}
            </span>
            <!-- 问诊拼接 -->
            <span class="pre" v-else-if="data.record.eventId === 'PatientNotEvaluateConsult'">
              {{ `问诊${data.record.businessId}${data.record.workOrderTask}` }}
            </span>
            <span v-else class="pre">
              <!-- 编号 -->
              <div
                v-html="brightenKeyword(data.record)"
                @click="handleDetail(data.record)"
                :class="{ pointer: data.record.serialNumber || data.record.reserveSn }"
              ></div>
            </span>
          </div>
        </template>
        <template #handle="{ record }">
          <a-button size="small" type="link" @click="viewDetails(record)">查看详情</a-button>
        </template>
      </a-table>
    </div>
    <ADetail ref="aDetail" :reserveSn="reserveSn" />
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
      :id="detail.id"
    />
  </div>
</template>

<script setup>
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { getWorkOrderList } from '@/api/Todo'
import { inputRule } from '@/utils/validate'
import { columnsTodo } from '@/views/Todo/config'
import { finishLabelMap, workOrderStatus } from '@/views/Todo/options'
import { SearchOutlined } from '@ant-design/icons-vue'
import { computed, nextTick, reactive, ref, watch } from 'vue'
import { subStringToType, brightenKeyword, maskPatientName } from '@/utils/index'
import { useStore } from 'vuex'
const store = useStore()
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const info = computed(() => store.state.patientFile.info)
const workOrderType = computed(() => store.getters.workorderDict) || []
const isAdmin = computed(() => store.state.user.isAdmin)
//控制输入规则
function inputR(e, key, type) {
  form.value[key] = inputRule(e.target.value, type)
}
const form = ref({
  workOrderIdListStr: '',
  workOrderIdList: [],
  businessType: null,
  state: null,
  sortType: null,
  stateTag: null
})
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const dataSource = ref([])
const loading = ref(false)
// 改变当前页
const onChangePage = (page, _, sorter = {}) => {
  const { field, order } = sorter
  if (order === 'descend') {
    // 降序
    form.value.sortType = 1
    form.value.sort = field
  } else if (order === 'ascend') {
    // 升序
    form.value.sortType = 0
    form.value.sort = field
  } else {
    form.value.sortType = null
    form.value.sort = ''
  }
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getList()
}
// 接口请求
const getList = () => {
  const { ucDoctorId } = doctorInfo.value
  const { ucPatientId } = info.value
  dataSource.value = []
  if (!ucPatientId) return
  form.value.workOrderIdList = form.value.workOrderIdListStr
    ? form.value.workOrderIdListStr.split('、')
    : []
  const params = {
    workOrderIdList: [],
    businessType: '',
    state: '',
    sortType: '',
    stateTag: '',
    ucPatientId,
    ucDoctorId,
    curPage: pagination.value.current,
    pageSize: pagination.value.pageSize,
    // 将数据进行解析
    ...form.value
  }
  loading.value = true
  getWorkOrderList(params)
    .then(result => {
      const { totalCount = 0, list = [] } = result
      dataSource.value = list
      pagination.value.total = totalCount
      pagination.value.showTotal = () => `共${totalCount}条`
    })
    .finally(_ => {
      loading.value = false
    })
}
// 重置
const reset = () => {
  form.value = {
    workOrderIdList: [],
    businessType: null,
    state: null,
    sortType: null,
    stateTag: null
  }
}
// 查看处方单、预约单详情
const detail = reactive({
  // the detail
  detailVisible: false,
  serialNumber: '',
  recordType: '',
  id: ''
})
const aDetail = ref(null)
const reserveSn = ref('')
const handleDetail = record => {
  const { serialNumber, businessType, reserveSn: reserveId, follUpPlanId } = record
  if (businessType === 7) {
    if (!reserveId) return
    reserveSn.value = reserveId.toString()
    nextTick(() => {
      aDetail.value.mVisible = true
      aDetail.value.initDetail()
    })
  } else if (businessType === 11 || businessType === 12) {
    if (!follUpPlanId) return
    detail.detailVisible = true
    detail.id = follUpPlanId
    detail.recordType = 'visit'
  } else {
    if (!serialNumber) return
    detail.serialNumber = serialNumber
    detail.recordType = subStringToType(serialNumber)
    detail.detailVisible = true
  }
}
// 查看工单详情
const showAllDialog = ref(false)
const currentInfo = ref({})
const viewDetails = data => {
  showAllDialog.value = true
  currentInfo.value = data
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
watch(
  () => [info.value.ucPatientId, doctorInfo.value.ucDoctorId],
  () => {
    onChangePage()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.WorkMange {
  .search {
    margin-bottom: 20px;
    display: flex;
    .component {
      width: 220px;
      margin-right: 12px;
      &:last-child {
        margin-right: 24px;
      }
    }
  }
}
</style>
